import { Directive, ElementRef, inject, signal } from '@angular/core';

/**
 * Directiva de aparición al hacer scroll (IntersectionObserver).
 * Añade la clase `visible` al entrar en viewport; el SCSS del host aplica
 * la transición (fade + slide-up). Respeta `prefers-reduced-motion`.
 */
@Directive({
  selector: '[appReveal]',
  standalone: true,
  host: {
    '[class.visible]': 'visible()',
  },
})
export class RevealDirective {
  private readonly el = inject(ElementRef<HTMLElement>);

  readonly visible = signal(false);

  constructor() {
    if (typeof IntersectionObserver === 'undefined') {
      this.visible.set(true);
      return;
    }
    const observar = new IntersectionObserver(
      (entradas) => {
        for (const entrada of entradas) {
          if (entrada.isIntersecting) {
            this.visible.set(true);
            observar.disconnect();
          }
        }
      },
      { threshold: 0.15 },
    );
    observar.observe(this.el.nativeElement);
  }
}
